import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';

class Image extends Component {
  constructor(props) {
    super(...arguments);

    const { src } = this.props;
    const loader = new window.Image();
    loader.src = '';
    loader.onload = () => this.didLoad();
    loader.onerror = () => console.warn('Error loading image: ' + src);
    loader.src = src;

    this.state = {
      loaded: false,
      classes: cx('Image preload', props.className),
      styles: cx('Image', props.styleName)
    };
  }

  didLoad() {
    if (this.outOfView) return;
    const { className } = this.props;
    const classes = `${className}`;
    const loaded = true;
    this.props.onImgLoad();
    this.setState({ classes, loaded });
  }

  componentWillUnmount() {
    this.outOfView = true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.className !== this.props.className) {
      this.setState({ classes: this.props.className });
    }
  }

  render() {
    const { src, alt, style, bg, children, onMouseMove, sizes, srcSet, priority } = this.props;
    const { classes } = this.state;
    let bgStyle = {
      backgroundColor: 'white',
      backgroundImage: `url(${src})`,
      ...style
    };

    const styleNames = cx('Image', {
      'opacity-0': !this.state.loaded,
      'opacity-1': this.state.loaded
    });

    if (!bg) {
      return (
        <img
          onMouseMove={onMouseMove}
          loading={priority ? 'eager' : 'lazy'}
          className={cx('Image', styleNames, classes)}
          style={style}
          srcSet={srcSet}
          sizes={sizes}
          src={src}
          alt={alt}
        />
      );
    }

    return (
      <div
        onMouseMove={onMouseMove}
        className={cx('Image', styleNames, classes)}
        style={bgStyle}
      >
        {children}
      </div>
    );
  }
}

Image.propTypes = {
  alt: PropTypes.string,
  bg: PropTypes.bool,
  src: PropTypes.string.isRequired,
  sizes: PropTypes.string,
  srcSet: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  styleName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onImgLoad: PropTypes.func,
  onMouseMove: PropTypes.func,
  priority: PropTypes.bool,
};

Image.defaultProps = {
  alt: '',
  bg: false,
  src: '',
  sizes: '',
  srcSet: '',
  style: {},
  children: null,
  className: 'w100',
  onImgLoad: (f) => f,
  onMouseMove: (f) => f,
  priority: false,
};

export default Image;
